export const getCreateBaitCheckerTimeout = (csvString: string) => {
  const valuesArray = csvString.split(',');
  return valuesArray.length * 3000 + 300;
};
